import React from "react"
import { NavList, NavListItem } from "@kuali/kuali-ui/lib/nav-lists"
import "./secondary-sidebar.scss"
import { SidebarNestedLinkConfig } from "./types"

export const SecondaryNavLinks = ({
  secondaryLinkData
}: {
  secondaryLinkData: Array<SidebarNestedLinkConfig>
}): NavListItem => {
  return secondaryLinkData.map((navItem, index) => {
    const isActive = navItem.isActive
    const isNestedActive = navItem.isExpanded

    return [
      <li key={`list-${navItem.title}-${index}`}>
        {!navItem.children && (
          <NavListItem
            active={isActive}
            aria-current={isActive ? "page" : undefined}
            href={navItem.href}
            container="a"
            target={navItem.target}
          >
            {navItem.title}
          </NavListItem>
        )}
        {/* Handle all levels of nested children and recurse if necessary */}
        {navItem.children && (
          <NavListItem defaultNestedCollapsed={!isNestedActive}>
            {navItem.title}
            <NavList>
              {navItem.children.map((nestedNavItem, index) => {
                const isActive = nestedNavItem.isActive
                const isExpanded = nestedNavItem.isExpanded

                if (nestedNavItem.children) {
                  return (
                    <NavListItem
                      key={`nested-child-list-item-${nestedNavItem.title}-${index}`}
                      aria-current={isActive ? "page" : undefined}
                      active={isActive}
                      defaultNestedCollapsed={!isExpanded}
                    >
                      {nestedNavItem.title}
                      <NavList>
                        <SecondaryNavLinks
                          secondaryLinkData={nestedNavItem.children}
                        />
                      </NavList>
                    </NavListItem>
                  )
                } else {
                  return (
                    <NavListItem
                      key={`child-list-item-${nestedNavItem.title}-${index}`}
                      active={isActive}
                      aria-current={isActive ? "page" : undefined}
                      container="a"
                      target={nestedNavItem.target}
                      href={nestedNavItem.href}
                    >
                      {nestedNavItem.title}
                    </NavListItem>
                  )
                }
              })}
            </NavList>
          </NavListItem>
        )}
      </li>
    ]
  })
}
